import React, { useState, useEffect } from "react";
import '../../../styles/Header-css/ServicePartner/PartnerVerification/ProfileSetup.css';
import { updatePartnerProfile } from "../../../../api/partner/profile";
const ProfileStep = ({ data, onDataChange, onNext, errors }) => {
  const [isGettingLocation, setIsGettingLocation] = useState(false);
  
  // --- Location Popup State ---
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
   const [saving, setSaving] = useState(false);
  //CALL API
  const handleSubmit = async (e) => {
    e.preventDefault();
    const dto = {
     // partnerId: Number(localStorage.getItem("user_id")),
     // partnerId: Number(10),
      partnerType: data.accountType === "business" ? "BUSINESS" : "INDIVIDUAL",
      businessName: data.businessName || null,
      addressLine1: `${data.homeFlat || ""}, ${data.street || ""}, ${data.village || ""}`.replace(/^,\s*/,""),
      addressLine2: data.landmark || "",
      city: data.village || "",
      // state: data.state || "",
      // postalCode: data.postalCode || "",
     // latitude: data.latitude || null,
     // longitude: data.longitude || null,
      // label: "Primary"
    };
    try {
      setSaving(true);
      console.log("Token "+localStorage.getItem("token"));
      await updatePartnerProfile(dto,localStorage.getItem("token"));
      onNext();
    } catch (err) {
      console.error("Profile save failed", err);
      alert("Failed to save profile. Please try again.");
    } finally {
      setSaving(false);
    }
    //onNext();
  };

  const handleAccountTypeChange = (value) => {
    onDataChange({ target: { name: "accountType", value } });
  };

  const handleInputChange = (e) => {
    onDataChange(e);
  };

  // --- Logic for Phone Change Button ---
  const handlePhoneChangeClick = () => {
    // Example logic: Clear the phone field and focus it so user can re-type
    onDataChange({ target: { name: "phone", value: "" } });
    const phoneInput = document.getElementById("phone");
    if (phoneInput) phoneInput.focus();
  };

  // --- 1. Get Current Location (GPS) ---
  const getCurrentLocation = () => {
    if (!navigator.geolocation) {
      alert("Geolocation is not supported by this browser.");
      return;
    }

    setIsGettingLocation(true);

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        try {
          const response = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&addressdetails=1`
          );
          const result = await response.json();
          processLocationResult(result, latitude, longitude);
        } catch (error) {
          console.error("Error fetching address:", error);
          alert("Failed to get location details.");
        } finally {
          setIsGettingLocation(false);
        }
      },
      (error) => {
        console.error("Error getting location:", error);
        setIsGettingLocation(false);
        alert("Unable to get your current location. Please check permissions.");
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }
    );
  };

  // --- 2. Auto-Search Logic (Effect) ---
  useEffect(() => {
    if (searchQuery.length < 3) {
      setSearchResults([]);
      return;
    }

    const timeoutId = setTimeout(async () => {
      setIsSearching(true);
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(searchQuery)}&addressdetails=1&limit=5`
        );
        const results = await response.json();
        setSearchResults(results);
      } catch (error) {
        console.error("Search error:", error);
      } finally {
        setIsSearching(false);
      }
    }, 1000); 

    return () => clearTimeout(timeoutId);
  }, [searchQuery]);

  // --- Helper: Process and set data from API result ---
  const processLocationResult = (result, lat, lon) => {
    if (result) {
      onDataChange({ target: { name: "currentLocation", value: result.display_name || "" } });
      onDataChange({ target: { name: "latitude", value: lat.toString() } });
      onDataChange({ target: { name: "longitude", value: lon.toString() } });

      const addr = result.address || {};
      
      const streetVal = addr.road || addr.pedestrian || addr.street || "";
      if(streetVal) onDataChange({ target: { name: "street", value: streetVal } });

      const cityVal = addr.village || addr.town || addr.city || addr.suburb || addr.county || "";
      if(cityVal) onDataChange({ target: { name: "village", value: cityVal } });

      setShowLocationModal(false);
      setSearchResults([]);
      setSearchQuery("");
    }
  };

  return (
    <>
      <h2>Complete Your Profile</h2>

      <div className="onboarding-card">
        <h3>Profile Setup</h3>
        <p>Complete your profile to start your journey with Ready2Rental</p>
      </div>

      <form onSubmit={handleSubmit}>
        {/* Account Type */}
        <div className="onboarding-radio-group">
          <label className="onboarding-radio-label">
            <input
              type="radio"
              name="accountType"
              value="individual"
              checked={data.accountType === "individual"}
              onChange={() => handleAccountTypeChange("individual")}
              className="onboarding-radio-input"
            />
            <span className="onboarding-radio-custom"></span>
            <span>Individual</span>
          </label>

          <label className="onboarding-radio-label">
            <input
              type="radio"
              name="accountType"
              value="business"
              checked={data.accountType === "business"}
              onChange={() => handleAccountTypeChange("business")}
              className="onboarding-radio-input"
            />
            <span className="onboarding-radio-custom"></span>
            <span>Business</span>
          </label>
        </div>

        {/* Full Name */}
        <div className="onboarding-form-group">
          <label htmlFor="fullname">Full Name *</label>
          <input
            type="text"
            name="fullname"
            id="fullname"
            className="onboarding-form-control"
            placeholder="Enter your full name"
            value={data.fullname || ""}
            onChange={handleInputChange}
            required
          />
          {errors.fullname && <div className="onboarding-error-message">{errors.fullname}</div>}
        </div>

        {/* Phone Number with Change Button */}
        <div className="onboarding-form-group">
          <label htmlFor="phone">Phone Number *</label>
          <div className="input-with-button">
            <input
              type="tel"
              name="phone"
              id="phone"
              className="onboarding-form-control"
              placeholder="Enter your phone number"
              value={data.phone || ""}
              onChange={handleInputChange}
              required
            />
            <button 
              type="button" 
              className="change-btn-inside"
              onClick={handlePhoneChangeClick}
            >
              Change
            </button>
          </div>
          {errors.phone && <div className="onboarding-error-message">{errors.phone}</div>}
        </div>

        {/* Current Location Section */}
        <div className="onboarding-form-group">
          <div className="onboarding-address-header">
            <label>Current Location *</label>
            <button
              type="button"
              className="onboarding-location-btn"
              onClick={() => setShowLocationModal(true)}
            >
              📍 Detect / Search Location
            </button>
          </div>
          
          <div className="onboarding-form-group">
            <label htmlFor="currentLocation">Detected Location *</label>
            <textarea
              name="currentLocation"
              id="currentLocation"
              className="onboarding-form-control"
              placeholder="Select location to auto-fill"
              value={data.currentLocation || ""}
              onChange={handleInputChange}
              rows="3"
              readOnly
              required
            />
            {errors.currentLocation && (
              <div className="onboarding-error-message">{errors.currentLocation}</div>
            )}
          </div>

          <input type="hidden" name="latitude" value={data.latitude || ""} />
          <input type="hidden" name="longitude" value={data.longitude || ""} />
        </div>

        {/* Current Address Details Section */}
        <div className="onboarding-form-group">
          <label className="onboarding-section-label">Current Address Details *</label>
          
          <div className="onboarding-form-group">
            <label htmlFor="homeFlat">Home/Flat Number *</label>
            <input
              type="text"
              name="homeFlat"
              id="homeFlat"
              className="onboarding-form-control"
              placeholder="Enter your house/flat number"
              value={data.homeFlat || ""}
              onChange={handleInputChange}
              required
            />
            {errors.homeFlat && <div className="onboarding-error-message">{errors.homeFlat}</div>}
          </div>

          <div className="onboarding-form-group">
            <label htmlFor="street">Street Name *</label>
            <input
              type="text"
              name="street"
              id="street"
              className="onboarding-form-control"
              placeholder="Enter street name"
              value={data.street || ""}
              onChange={handleInputChange}
              required
            />
            {errors.street && <div className="onboarding-error-message">{errors.street}</div>}
          </div>

          <div className="onboarding-form-group">
            <label htmlFor="village">Village/Town/City *</label>
            <input
              type="text"
              name="village"
              id="village"
              className="onboarding-form-control"
              placeholder="Enter village, town or city name"
              value={data.village || ""}
              onChange={handleInputChange}
              required
            />
            {errors.village && <div className="onboarding-error-message">{errors.village}</div>}
          </div>

          <div className="onboarding-form-group">
            <label htmlFor="landmark">Landmark (Optional)</label>
            <input
              type="text"
              name="landmark"
              id="landmark"
              className="onboarding-form-control"
              placeholder="Enter nearby landmark"
              value={data.landmark || ""}
              onChange={handleInputChange}
            />
          </div>
        </div>

        <div className="onboarding-button-group">
          <div></div>
          <button
            type="submit"
            className="onboarding-btn onboarding-btn-primary"
          >
            Next: KYC
          </button>
        </div>
      </form>

      {/* --- LOCATION SELECTION MODAL --- */}
      {showLocationModal && (
        <div className="location-modal-overlay">
          <div className="location-modal-content">
            <div className="location-modal-header">
              <h3>Select Location</h3>
              <button 
                type="button" 
                className="location-modal-close"
                onClick={() => setShowLocationModal(false)}
              >
                &times;
              </button>
            </div>

            <button
              type="button"
              className="onboarding-location-btn"
              style={{ width: "100%", justifyContent: "center", marginBottom: "10px" }}
              onClick={getCurrentLocation}
              disabled={isGettingLocation}
            >
              {isGettingLocation ? "Fetching..." : "📍 Use Current GPS Location"}
            </button>

            <div className="location-or-divider">- OR -</div>

            <input 
              type="text" 
              className="onboarding-form-control"
              placeholder="Start typing city or area..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              autoFocus
            />

            {isSearching && <div className="loading-text">Searching...</div>}

            {searchResults.length > 0 && !isSearching && (
              <ul className="search-results-list">
                {searchResults.map((result) => (
                  <li 
                    key={result.place_id} 
                    className="search-result-item"
                    onClick={() => processLocationResult(result, result.lat, result.lon)}
                  >
                    {result.display_name}
                  </li>
                ))}
              </ul>
            )}
            
            {!isSearching && searchQuery.length >= 3 && searchResults.length === 0 && (
              <div className="loading-text">No results found.</div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ProfileStep;